import { render, staticRenderFns } from "./envelope-documents.vue?vue&type=template&id=38d3e29a&scoped=true"
import script from "./envelope-documents.vue?vue&type=script&lang=js"
export * from "./envelope-documents.vue?vue&type=script&lang=js"
import style0 from "./envelope-documents.vue?vue&type=style&index=0&id=38d3e29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3e29a",
  null
  
)

export default component.exports